export default {
  debug: false
}
